import { render, staticRenderFns } from "./VcDashedButton.vue?vue&type=template&id=a5d78d0e&scoped=true"
import script from "./VcDashedButton.vue?vue&type=script&lang=js"
export * from "./VcDashedButton.vue?vue&type=script&lang=js"
import style0 from "./VcDashedButton.vue?vue&type=style&index=0&id=a5d78d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d78d0e",
  null
  
)

export default component.exports